import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { buildPageTitle } from '../../utils';

const Head = ({ title, ...otherProps }) => {

    useEffect(() => {

        document.title = buildPageTitle(title);

    }, [title]);

    if (__CLIENT__) {

        return null;

    }

    return (
        <Route
            render={({ staticContext }) => {

                if (staticContext) {

                    staticContext.pageConfig = {
                        title,
                        ...otherProps,
                    };

                }
                return null;

            }}
        />
    );

};

Head.propTypes = {
    title: PropTypes.string.isRequired,
};

export default Head;
